import React from "react";
import {
  Card,
  TabsCustom,
  TabsCustomHeader,
  TabsCustomMenu,
  TabsCustomBody,
  TabsCustomItem,
} from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

export default class Parts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabsIndex: 0,
      openCards: {},
    };
  }

  toggleCard = (key) => {
    this.setState((prev) => ({
      openCards: {
        ...prev.openCards,
        [key]: !prev.openCards[key],
      },
    }));
  };

  getLabel(reference, items) {
    const { parts } = this.props;

    if (parts && parts.length) {
      const match = parts.find((p) => p["Ref_Constructeur"] === reference);
      if (match && match["Libelle"]) return match["Libelle"];
    }

    if (items.length && items[0].name) return items[0].name;

    return reference;
  }

  getReportPrice(reference) {
    const { parts } = this.props;
    if (!parts || !parts.length) return null;
    const match = parts.find((p) => p["Ref_Constructeur"] === reference);
    if (match && match["Prix_U"]) {
      return parseFloat(match["Prix_U"].replace(",", "."));
    }
    return null;
  }

  groupByReference(items) {
    const groups = {};
    for (const item of items) {
      const ref = item.reference || "Sans référence";
      if (!groups[ref]) {
        groups[ref] = [];
      }
      groups[ref].push(item);
    }
    return groups;
  }

  renderTable(items) {
    return (
      <table className="w-100" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "2px solid #e2e8f0", textAlign: "left" }}>
            <th style={{ padding: "8px" }}>Image</th>
            <th style={{ padding: "8px" }}>Nom</th>
            <th style={{ padding: "8px" }}>État</th>
            <th style={{ padding: "8px" }}>Prix</th>
            <th style={{ padding: "8px" }}>Fournisseur</th>
            <th style={{ padding: "8px" }}>Lien</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx} style={{ borderBottom: "1px solid #e2e8f0" }}>
              <td style={{ padding: "8px" }}>
                {item.image ? (
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                  />
                ) : (
                  <span style={{ color: "#a0aec0" }}>—</span>
                )}
              </td>
              <td style={{ padding: "8px" }}>
                <b>{item.name}</b>
              </td>
              <td style={{ padding: "8px" }}>{item.condition || "—"}</td>
              <td style={{ padding: "8px" }}>
                <b>
                  {item.price != null ? `${item.price.toFixed(2)} €` : "—"}
                </b>
              </td>
              <td style={{ padding: "8px" }}>{item.from || "—"}</td>
              <td style={{ padding: "8px" }}>
                {item.url ? (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Voir
                  </a>
                ) : (
                  "—"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  renderGroupedCards(items, prefix) {
    const grouped = this.groupByReference(items);
    const entries = Object.entries(grouped);

    if (!entries.length) {
      return (
        <Card className="mt-10">
          <p>Aucune pièce disponible</p>
        </Card>
      );
    }

    return entries.map(([reference, parts]) => {
      const key = `${prefix}-${reference}`;
      const isOpen = this.state.openCards[key] || false;
      const label = this.getLabel(reference, parts);
      const priceReport = this.getReportPrice(reference);

      return (
        <Card key={key} className="mb-10">
          <div
            onClick={() => this.toggleCard(key)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
              padding: "4px 0",
            }}
          >
            <div>
              <b>{label}</b>
              <span style={{ color: "#718096", marginLeft: "12px" }}>
                Réf. {reference}
              </span>
              {priceReport != null && (
                <span style={{ color: "#718096", marginLeft: "12px" }}>
                  Prix rapport : {priceReport.toFixed(2)} €
                </span>
              )}
              <span
                style={{
                  marginLeft: "12px",
                  fontSize: "0.85em",
                  color: "#4a5568",
                }}
              >
                {parts.length} résultat{parts.length > 1 ? "s" : ""}
              </span>
            </div>
            <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
          </div>
          {isOpen && (
            <div style={{ marginTop: "12px" }}>{this.renderTable(parts)}</div>
          )}
        </Card>
      );
    });
  }

  render() {
    const { piec, pqe } = this.props;

    return (
      <TabsCustom noCard>
        <TabsCustomHeader>
          <TabsCustomMenu
            title={`PIEC (${piec.length})`}
            active={this.state.tabsIndex === 0}
            onClick={() => this.setState({ tabsIndex: 0 })}
          />
          <TabsCustomMenu
            title={`PQE (${pqe.length})`}
            active={this.state.tabsIndex === 1}
            onClick={() => this.setState({ tabsIndex: 1 })}
          />
        </TabsCustomHeader>
        <TabsCustomBody noCard>
          <TabsCustomItem active={this.state.tabsIndex === 0}>
            {this.renderGroupedCards(piec, "piec")}
          </TabsCustomItem>
          <TabsCustomItem active={this.state.tabsIndex === 1}>
            {this.renderGroupedCards(pqe, "pqe")}
          </TabsCustomItem>
        </TabsCustomBody>
      </TabsCustom>
    );
  }
}
